// extracted by mini-css-extract-plugin
export var controls = "Slider-module--controls--490eb";